import { render, staticRenderFns } from "./permission_denied.vue?vue&type=template&id=e134fade&scoped=true&"
import script from "./permission_denied.vue?vue&type=script&lang=js&"
export * from "./permission_denied.vue?vue&type=script&lang=js&"
import style0 from "./permission_denied.vue?vue&type=style&index=0&id=e134fade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e134fade",
  null
  
)

export default component.exports